<template>
  <div class="max-w-2xl mx-auto mt-20 md:px-0" v-if="settings">
    <h1
      class="font-sans text-xl font-semibold text-center md:text-center md:font-bold md:text-3xl"
    >
      {{ settings?.title }}
    </h1>
    <p class="mt-5 text-gray-700 md:text-center">
      {{ settings?.sub_title }}
    </p>
  </div>

  <div class="max-w-5xl mx-auto mt-5 md:px-0" v-if="listings">
    <div>
      <header class="flex items-center justify-between mb-4">
        <p class="mt-2 text-gray-700">
          Discover how we can help you find your dream home
        </p>
      </header>

      <div class="mx-4">
        <vue-horizontal
          responsive
          class="horizontal"
          :displacement="0.7"
          snap="center"
        >
          <a
            :href="
              $router.resolve({
                name: 'PropertyView',
                params: {
                  id: property.id,
                  slug: property.title ? $sanitizeTitle(property.title) : '',
                },
              }).href
            "
            class="flex mx-2"
            v-for="property in listings.data"
            :key="property.id"
          >
            <div class="flex flex-col items-start w-56">
              <div
                class="max-w-[300px] max-h-[300px] overflow-hidden rounded-md"
              >
                <img
                  :src="property.photos[0]"
                  class="object-cover w-56 h-40 transition duration-500 rounded-md cursor-pointer hover:scale-110"
                  alt=""
                />
              </div>

              <div class="flex flex-col">
                <h1 class="text-xl font-semibold text-gray-800 text-start">
                  {{ formattedAmount(Number(property.price), 2) }}
                </h1>
                <div class="flex space-x-2 font-medium">
                  <div
                    class="flex items-center justify-center"
                    v-if="property.number_of_beds"
                  >
                    <BedSvg color="black" height="4" width="4" />
                    <p class="pl-1 text-xs">{{ property.number_of_beds }}bd</p>
                  </div>
                  <div
                    class="flex items-center justify-center"
                    v-if="property.number_of_baths"
                  >
                    <BathSvg color="black" height="4" width="4" />
                    <p class="pl-1 text-xs">{{ property.number_of_baths }}ba</p>
                  </div>
                  <div
                    class="flex items-center justify-center"
                    v-if="property.property_size"
                  >
                    <PropertySizeSvg color="black" height="3" width="3" />
                    <p class="pl-1 text-xs truncate">
                      {{ $truncate(property.property_size, 12) }}
                    </p>
                  </div>
                </div>
                <p
                  class="text-sm font-normal tracking-wide truncate text-start"
                >
                  {{ $truncate(property.address, 40) }}
                </p>
                <p class="text-[10px] text-start uppercase truncate">
                  {{ $truncate(property.title, 40) }}
                </p>
              </div>
            </div>
          </a>
        </vue-horizontal>
      </div>
    </div>
  </div>
</template>
<script>
import BathSvg from "@/components/svg/BathSvg.vue";
import BedSvg from "@/components/svg/BedSvg.vue";
import PropertySizeSvg from "@/components/svg/PropertySizeSvg.vue";
import VueHorizontal from "vue-horizontal";
export default {
  components: {
    VueHorizontal,
    PropertySizeSvg,
    BedSvg,
    BathSvg,
  },
  props: {
    listings: Object,
    settings: Object,
  },
  data() {
    return {};
  },

  methods: {},
};
</script>
